import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { RouterModule } from '@angular/router';
import { UserFormComponent } from './user-form/user-form.component';
import { UserButtonComponent } from './user-button/user-button.component';
import { UserCheckComponent } from './user-check/user-check.component';
import { UserInputComponent } from './user-input/user-input.component';
import { ContentWindowComponent } from './content-window/content-window.component';
import { ContentListComponent } from './content-list/content-list.component';
import { ContentListItemComponent } from './content-list-item/content-list-item.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { LoadingComponent } from './loading/loading.component';
import { ErrorComponent } from './error/error.component';
import { FormatDatePipe } from './pipes/formatdate.pipe';
import { FormatNumberPipe } from './pipes/formatnumber.pipe';
import { ListFilterPipe } from './pipes/listfilter.pipe';
import { FormatDateAsNamePipe } from './pipes/formatdateasname.pipe';
import { GoogleMapsComponent } from './google-maps/google-maps.component';
import { UserDateComponent } from './user-date/user-date.component';
import { MyDatePickerModule } from 'mydatepicker';
import { ListComponent } from './list/list.component';
import { ListItemComponent } from './list-item/list-item.component';
import { ModalWindowComponent } from './login-modal/login-modal.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { SetRouteClassDirective } from './set-route-class/set-route-class.directive';
import { InfoBoxComponent } from './info-box/info-box.component';
import { InfoBoxFooterComponent } from './info-box-footer/info-box-footer.component';
import { ContextMenuComponent } from './context-menu/context-menu.component';
import { EnterToButtonDirective } from './directives/entertobutton.directive';
import { FocusDirective } from './directives/focus.directive';
import { InlineLoadingComponent } from './inline-loading/inline-loading.component';
import { ViewportVisibleDirective } from './directives/viewportvisible.directive';
import { EnclosedDirective } from './directives/enclosed.directive';
import { ConfirmComponent } from './confirm/confirm.component';
import { ManualBreadcrumbsComponent } from './manual-breadcrumbs/manual-breadcrumbs.component';
import { ScrollWatcherDirective } from './scroll-watcher.directive';
import { StateConverterPipe } from './pipes/stateconverter.pipe';
import { AdminMenuComponent } from '../components/menu/admin-menu.component';
import { CarrierMenuComponent } from '../components/menu/carrier-menu.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { TourListItemComponent } from './tour-list-item/tour-list-item.component';
import { TableModule } from './table/table.module';
import { UserSelectComponent } from './user-select/user-select.component';
import { CollapsibleComponent } from './collapsible/collapsible.component';
import { CollapsibleHeaderComponent } from './collapsible/collapsible-header/collapsible-header.component';
import { UserNumberComponent } from './user-number/user-number.component';
import { UserInput2Component } from './user-input2/user-input2.component';
import { UserButton2Component } from './user-button2/user-button2.component';
import { IconDocumentComponent } from './icons/icon-document/icon-document.component';
import { UserModalComponent } from './user-modal/user-modal.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    MyDatePickerModule,
    TableModule,
    RouterModule
  ],
  declarations: [
    AdminMenuComponent,
    CarrierMenuComponent,
    UserFormComponent,
    UserButtonComponent,
    UserCheckComponent,
    UserInputComponent,
    UserDateComponent,
    ContentWindowComponent,
    ContentListComponent,
    ContentListItemComponent,
    ProgressBarComponent,
    LoadingComponent,
    ErrorComponent,
    FormatDatePipe,
    FormatNumberPipe,
    ListFilterPipe,
    FormatDateAsNamePipe,
    GoogleMapsComponent,
    ListComponent,
    ListItemComponent,
    ModalWindowComponent,
    BreadcrumbsComponent,
    ManualBreadcrumbsComponent,
    SetRouteClassDirective,
    InfoBoxComponent,
    InfoBoxFooterComponent,
    ContextMenuComponent,
    EnterToButtonDirective,
    FocusDirective,
    InlineLoadingComponent,
    ViewportVisibleDirective,
    EnclosedDirective,
    ConfirmComponent,
    ScrollWatcherDirective,
    StateConverterPipe,
    TooltipComponent,
    TourListItemComponent,
    UserSelectComponent,
    CollapsibleComponent,
    CollapsibleHeaderComponent,
    UserNumberComponent,
    UserInput2Component,
    UserButton2Component,
    IconDocumentComponent,
    UserModalComponent,
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    MyDatePickerModule,
    TableModule,
    AdminMenuComponent,
    CarrierMenuComponent,
    UserFormComponent,
    UserButtonComponent,
    UserCheckComponent,
    UserInputComponent,
    UserDateComponent,
    ContentWindowComponent,
    ContentListComponent,
    ContentListItemComponent,
    ProgressBarComponent,
    LoadingComponent,
    ErrorComponent,
    FormatDatePipe,
    FormatNumberPipe,
    ListFilterPipe,
    FormatDateAsNamePipe,
    GoogleMapsComponent,
    ListComponent,
    ListItemComponent,
    ModalWindowComponent,
    BreadcrumbsComponent,
    ManualBreadcrumbsComponent,
    SetRouteClassDirective,
    InfoBoxComponent,
    InfoBoxFooterComponent,
    ContextMenuComponent,
    EnterToButtonDirective,
    FocusDirective,
    InlineLoadingComponent,
    ViewportVisibleDirective,
    EnclosedDirective,
    ConfirmComponent,
    ScrollWatcherDirective,
    StateConverterPipe,
    TooltipComponent,
    TourListItemComponent,
    UserSelectComponent,
    CollapsibleComponent,
    CollapsibleHeaderComponent,
    UserNumberComponent,
    UserInput2Component,
    UserButton2Component,
    IconDocumentComponent,
    UserModalComponent,
  ]
})
export class SharedModule { }
